import React, {useEffect,useContext,useState} from 'react';
import {BtnDuplicateComptaConfig} from '@gull'
import { useTranslate } from 'react-redux-multilingual'
import { IsAuthContext } from 'app/App';

const SubmitAndSelectTypeCorrespondence = (props) => {
    const t = useTranslate();
    const { authParam } = useContext(IsAuthContext);
    const [moduleFacturationActive,setModuleFacturationActive] = useState(false)

    useEffect(function () {
        if(authParam.modules.find(value=>value.name=='invoice')){
            setModuleFacturationActive(true)
        }
    }, [])

    const handleSwitchConfType = (e) => {
        props.setSelectType(e.target.value)
        if(props.setVentilationArticleType) props.setVentilationArticleType('')
        if(props.setVentilationSelectDatas) props.setVentilationSelectDatas(false)
    };

    return(
        <div className="d-flex justify-content-between align-items_center mb-2">
            <div className='d-flex align-items-center'>
                <div className='form-group'>
                    <label>{t('configurationTypeSelection')}</label>
                    <select disabled={props.config=='caisse' || props.config=='commerce'} value={props.selectType} className='form-control' onChange={(e)=>handleSwitchConfType(e)}>
                        {moduleFacturationActive && <option value="vente_b2b">{t('b2bSale')}</option>}
                        <option value="vente_b2c">{t('b2cSale')}</option>
                        {(props.config!='acompte' && moduleFacturationActive) && <option value="achat_b2b">{t('purchase')}</option>}
                    </select>
                </div>
                {props.config!='journal' && props.config!='commerce' && props.config!='caisse' &&
                    <div style={{marginLeft:'1rem'}}>
                        <BtnDuplicateComptaConfig 
                            idCompany={props.idCompany}
                            config={props.config}
                            setReload={props.setReload}
                            selectType={props.selectType}
                            company={props.company}
                        />
                    </div>
                }
            </div>
            <div>
                <button 
                    disabled={props.disabledBtn || props.validButton} 
                    className='btn btn-primary' 
                    onClick={()=>props.handleSubmit()}
                >
                    {props.validButton ? <div className="spinner-border spinner-border-sm"></div> : t('btnValidate')}
                </button>
            </div>
        </div>
    )
}

export default SubmitAndSelectTypeCorrespondence;
